<template>
    <div>
        <div id="chart" :style="{height: chartHeight + 'px'}" style="position:relative; width:100%; display: flex; justify-content: space-between;">
            <!-- <div @click="activeLine(index)" v-for="(item , index) in chartData.line1.data" :key="index" style="height:205px"> -->
            <div v-for="(item, index) in chartData.series" :key="index" style="width: 100%;">
                <div v-for="(value , count) in item.data" :key="count">
                    <div v-if="index == 0" @mouseover="showInfo(count)" @mouseleave="hideInfo(count)" class="chart_line_wrap" 
                        :style="{
                            width: chartWidth + 'px',
                            right: (((chartData.size) - count) * (100 / chartData.size)) + '%'
                        }"
                        style="position: absolute; height: 100%; transform: translateX(50%); z-index:1000">
                        <div v-if="(count != 0) && (count != (item.data.length - 1))" class="chart_circle"
                            :style="{
                                bottom: item.data[count].percent + '%',
                                left: 50 + '%',
                                background: item.style.color,
                                width: item.style.circle + 'px', 
                                height:  item.style.circle + 'px', 
                            }"
                            style="position:absolute; transform: translate(-50%, 50%); border-radius: 100%; z-index: 998; transition: width 0.4s ease;">
                        </div>
                        <chevron-right-icon
                            v-if="count == (item.data.length - 1)"
                            :size="arrowSize + 'x'" 
                            :color="item.style.color" 
                            :style="{
                                bottom: item.data[count].percent + '%',
                                left: '50%',
                                transform: 'translate(-50%, 50%)' + 'rotate(' + Math.round(value.rotate) + 'deg)',
                                // transform: 'translate(-50%, 50%)'
                            }"
                            style="margin: 0; position:absolute; z-index: 998; transform-origin: center; transition: width 0.4s ease;"></chevron-right-icon>
                    </div>
                    <!-- <div v-if="value.active" class="chart_line" 
                        style="position: absolute; width: 0; height: 100%; border-left: 1px dashed #CCCCCC; left: 50%; bottom: 0; margin: 0"
                        :style="{
                            left: (100 / chartData.size) * count + '%'
                        }"
                    ></div> -->
                    <div class="date" 
                        :style="{
                            bottom: item.data[count].percent - ((count == (item.data.length - 1)) ? 2 : ((count == 0) ? 0 : (item.style.circle / 2) - 2)) + '%',
                            right: ((count == (item.data.length - 1)) ? (((chartData.size) - count) * (100 / chartData.size) + 20) : ((count == 0) ? (((chartData.size) - count) * (100 / chartData.size) - 7) : ((chartData.size) - count) * (100 / chartData.size))) + '%', 
                            fontSize: isMobile ? '15px' : '21px'
                        }"
                        style="position:absolute; transform: translate(100%, 50%); font-size: 21px; color: #CCCCCC; border-radius: 100%; z-index: 998; transition: width 0.4s ease;">
                        {{item.data[count].date}}
                    </div>
                    <div v-if="count != 0" :style="{
                        width: chartWidth + 'px', 
                        bottom: item.data[count - 1].percent + '%',
                        height: (value.height - item.data[count - 1].height) + 'px',
                        right: (((chartData.size) - count) * (100 / chartData.size)) + '%',
                        background: 'linear-gradient(' + Math.round(value.rotate) + 'deg, transparent 50%, white 50%)'}" style="height: 100%; position:absolute;">

                    </div>
                    <div v-if="count != 0" :style="{
                        width: chartWidth + 'px', 
                        top: 0 + '%',
                        height: 100 - (item.data[count].percent) + '%',
                        right: (((chartData.size) - count) * (100 / chartData.size)) + '%'}" style="background: white; position:absolute;">

                    </div>
                    <!-- <div v-if="(count != 0) && (count != (item.data.length - 1))" class="chart_circle"
                        :style="{
                            bottom: item.data[count].percent + '%',
                            left: ((count - 1) * (100 / chartData.size)) + '%',
                            background: item.style.color,
                            width: item.style.circle + 'px', 
                            height:  item.style.circle + 'px', 
                        }"
                        style="position:absolute; transform: translate(calc(50% - 1px), 50%); border-radius: 100%; z-index: 998; transition: width 0.4s ease;">
                    </div> -->
                    <div v-if="count != 0" :style="{
                            maxWidth: value.width + 'px',
                            height: item.style.border, 
                            bottom: item.data[count - 1].percent + '%',
                            transform: 'rotate(' + Math.round(value.rotate) + 'deg) translateY(50%)',
                            left: setLeft(value, count),
                            outlineColor: item.style.color + '!important',
                            background: item.style.color,
                            animationDelay: 100 * count + 'ms'
                        }"
                        style="position: absolute; transform-origin: left center; border-radius: 5px; animation: width 0.5s ease; animation-fill-mode: forwards;"
                        >
                    </div>
                    <div v-if="count != 0" :style="{
                            maxWidth: value.width + 'px',
                            height: item.style.border, 
                            background: item.style.color,
                            bottom: item.data[count - 1].percent + '%',
                            transform: 'rotate(' + Math.round(value.rotate) + 'deg) translateY(50%)',
                            left: setLeft(value, count),
                            background: item.style.color,
                            animationDelay: 100 * count + 'ms'
                        }"
                        style="position: absolute; transform-origin: left center; border-radius: 5px; animation: widthSub 0.5s ease; animation-fill-mode: forwards;"
                        >
                    </div>
                    <!-- {{((count - 1) * 20) - Math.floor((1 - (Math.cos(Math.PI/180 * value.rotate))) * 18)}} -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Dayjs from 'dayjs'
import { ChevronRightIcon } from 'vue-feather-icons'
export default {
    props: ['data', 'info', 'height'],
    data() {
        return {
            chartWidth: null,
            chartHeight: 220,
            chartData: null,
            showCloud: false,
            arrowSize: 4,
            activeLine: {
                
            },
            activeLineIndex: 0,
            maxValue: 0
        }
    },
    components: {
        ChevronRightIcon
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile
        }
    },
    watch: {
        chartWidth() {
            this.initChart()
        }
    },
    methods: {
        initChart() {
            console.log(document.getElementById('chart').offsetWidth)
            this.chartWidth = (document.getElementById('chart').offsetWidth) / this.chartData.size
            for(var i in this.chartData.series) {
                for(var j in this.chartData.series[i].data){
                    this.chartData.series[i].data[j].height = (this.chartData.series[i].data[j].percent / 100) * this.chartHeight
                    if(j > 0) {
                        var result = this.getSqaure(this.chartWidth, this.chartData.series[i].data[j].height - this.chartData.series[i].data[j - 1].height)
                        this.$set(this.chartData.series[i].data[j] , 'width' , result)
                        this.$set(this.chartData.series[i].data[j] , 'rotate' , this.getAngle(this.chartData.series[i].data[j - 1].height , this.chartData.series[i].data[j].height, this.chartWidth))
                    }
                }
            }
        },
        getSqaure(width , height) {
            var square = Math.sqrt(Math.pow(width , 2) + Math.pow(height , 2))
            return square
        },
        getAngle(y1 , y2 , x) {
            var angle = Math.atan2(y1 - y2 , x)
            var result = (angle * 180) / Math.PI
            return result
        },
        handleResize() {
            this.chartWidth = (document.getElementById('chart').offsetWidth) / 5
        },
        setLeft(value, count) {
            // (((chartData.size - 1) - count) * (100 / chartData.size)) + '%'
            return ((count - 1) * (100 / this.chartData.size)) + '%'
        },
        showInfo(count) {
            var sum = 0
            for(var i in this.chartData.series) {
                this.$set(this.chartData.series[i].data[count], 'active', true)
                this.$set(this.activeLine, this.chartData.series[i].name, this.chartData.series[i].data[count])
                sum += Number(this.uncomma(this.chartData.series[i].data[count].label))
            }
            this.activeLineIndex = count
            this.showCloud = true
            console.log(sum)
            this.$emit('cost', this.comma(sum))
        },
        hideInfo(count) {
            for(var i in this.chartData.series) {
                this.$set(this.chartData.series[i].data[count], 'active', false)
                this.$set(this.activeLine, this.chartData.series[i].name, null)
            }
            this.activeLineIndex = null
            this.showCloud = false
        },
        setBoxBottom() {
            for(const property of Object.keys(this.activeLine)) {
                var number = Math.max(this.activeLine[property].percent)
            }
            if(number > 60) {
                return number - 50
            } else {
                return number
            }
        },
        setMonth() {
            return Dayjs(this.activeLine.part_time.date).format('M')
        },
        comma(val) {
            if(val) {
                var target = String(val)
                return target.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,')
            } else {
                return 0
            }
        },
        uncomma(val) {
            val = String(val)
            return val.replace(/[,]+/g, '')
        }
    },
    mounted() {
        this.initChart()
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
    created() {
        if(this.height) {
            this.chartHeight = JSON.parse(JSON.stringify(this.height))
        }
        this.chartData = JSON.parse(JSON.stringify(this.info))
    }
}
</script>
<style>
    #chart {
        /* animation: gradient 3s ease infinite; */
        background: linear-gradient(270deg, rgba(29, 119, 255, 0.1) 0%, rgba(239, 245, 255, 0) 100%);
    }
    @keyframes gradient {
        from {
            background: linear-gradient(270deg, rgba(29, 119, 255, 0.1) 0%,rgba(239, 245, 255, 0) 0%);
        }
        to {
            background: linear-gradient(270deg, rgba(29, 119, 255, 0.1) 0%, rgba(239, 245, 255, 0) 100%);
        }
    }
    @keyframes width {
        from {
            width: 0;
            outline: 2px solid;
        }
        to {
            width: 100%;
            outline: 2px solid;
        }
    }
    @keyframes widthSub {
        from {
            width: 0;
        }
        to {
            width: 100%;
        }
    }
</style>